import { render } from "./ai-form-number-box-readonly.vue?vue&type=template&id=4c051805"
import script from "./ai-form-number-box-readonly.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-form-number-box-readonly.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/card-component/ai-form-number-box-readonly.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c051805"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c051805', __exports__)) {
    api.reload('4c051805', __exports__)
  }
  
  module.hot.accept("./ai-form-number-box-readonly.vue?vue&type=template&id=4c051805", () => {
    api.rerender('4c051805', render)
  })

}


export default __exports__